/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const PowerPassengerSeat = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M23.06 19.49a2.46 2.46 0 0 0-2.35-.7c-2.4.25-7.86 1.39-10.81 2v-.09C12 16.26 8.41 11 6.7 8.49a11.86 11.86 0 0 1-.76-1.18C5.35 6.08 4.72 5.2 3.7 5h-.44c.14-.39.26-.66.38-.66.35 0 .5-.1.64-.59S3 1 3 1A2 2 0 0 0 .59.7c-.3.38 1.83 6.79 1.83 6.79l2.85 12.39a2.06 2.06 0 0 0-.21 1.57l1.23 3.83a.43.43 0 0 0 .41.3h15a.43.43 0 0 0 .41-.29l.89-2.58v-.06c.22-.54.83-2.17.06-3.16z" /><path d="M17.82 1c1.84-.21 3.13 1 3 3.11a4.76 4.76 0 0 1-.58 1.8c-.28.49-.9 1-.73 1.59.1.39 1 .62 1.28.76.8.35 1.92.87 2.2 1.71A2 2 0 0 1 23 11c-.45 1.16-3.22 1.22-4.76 1.22a17 17 0 0 1-2.81-.18c-1.07-.2-2.37-.63-2-2.05.17-.64.94-1.11 1.64-1.49a9 9 0 0 1 1-.52c.34-.14.81-.26.86-.7.05-.44-.2-.58-.43-.89a4.45 4.45 0 0 1-.92-3A2.48 2.48 0 0 1 17.82 1z" /></g>
      </g>
    </svg>
  </span>
);

PowerPassengerSeat.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

PowerPassengerSeat.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default PowerPassengerSeat;
